import * as yup from "yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import { saveAccountParentsInfoAsync } from "../../../../../services/accountService";
import Textbox from "../../../../../components/common/Textbox";
import Toaster from "./../../../../../components/common/Toaster";

const schema = yup.object({
  mother_first_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
  mother_middle_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
  mother_last_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
  father_first_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
  father_middle_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
  fathe_last_name: yup
    .string()
    .matches("^[a-zA-ZñÑ][a-zA-ZñÑ .-]*$", "Please enter a valid name."),
});

const ParentsForm = ({ id, data, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await saveAccountParentsInfoAsync(id, data);
      Toaster.Success("Information Saved Successfully");
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const populateForm = () => {
      if (data.length > 0) {
        setValue("mother_first_name", data[0].first_name);
        setValue("mother_middle_name", data[0].middle_name);
        setValue("mother_last_name", data[0].last_name);
        setValue("father_first_name", data[1].first_name);
        setValue("father_middle_name", data[1].middle_name);
        setValue("father_last_name", data[1].last_name);
      }
    };

    populateForm();
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2 border-b border-gray-200 mb-8">
          <p className="form-label">Mother's Maiden Name</p>
        </div>
        <div className="col-span-2">
          <Textbox
            id="mother-first-name-textbox"
            name="mother_first_name"
            type="text"
            title="First Name"
            placeholder="e.g. Jane"
            register={register("mother_first_name")}
            errors={errors}
            autoFocus
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="mother-middle-name-textbox"
            name="mother_middle_name"
            type="text"
            title="Middle Name"
            register={register("mother_middle_name")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="mother-last-name-textbox"
            name="mother_last_name"
            type="text"
            title="Last Name"
            placeholder="e.g. Dela Cruz"
            register={register("mother_last_name")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2 border-b border-gray-200 mb-8 mt-4">
          <p className="form-label">Father's Name</p>
        </div>
        <div className="col-span-2">
          <Textbox
            id="father-first-name-textbox"
            name="father_first_name"
            type="text"
            title="First Name"
            placeholder="e.g. Juan"
            register={register("father_first_name")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="father-middle-name-textbox"
            name="father_middle_name"
            type="text"
            title="Middle Name"
            register={register("father_middle_name")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="father-last-name-textbox"
            name="father_last_name"
            type="text"
            title="Last Name"
            placeholder="e.g. Dela Cruz"
            register={register("father_last_name")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default ParentsForm;
